module.exports = __webpack_public_path__ + "static/media/biot.db59a9c9.webp";